export default __webpack_public_path__ + "static/media/Seymour.00e0d09a.png";